import { render, staticRenderFns } from "./SideBarTickets.vue?vue&type=template&id=f4eb501e"
import script from "./SideBarTickets.vue?vue&type=script&lang=js"
export * from "./SideBarTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports